<template>
  <v-container class="fill-height">
    <v-row justify="space-around">

      <v-col cols="12"  sm="6" md="5" lg="4" xl="3" >

        <v-card class="shadowCard">

          <v-card-title>
            Iniciar sesión
          </v-card-title>

          <v-card-text class="mt-2 pb-0" align="center">
            <v-form 
              ref="form"
              v-model="valid"
              lazy-validation>
              <v-text-field
                autofocus
                v-model="email" 
                :rules="[rules.required]"
                append-icon="mdi-email" 
                label="Usuario" 
                required
                type="text"
                filled
                dense 
                clearable
                single-line
                >
              </v-text-field>

              <v-text-field
                v-model="password"
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required, rules.min]"
                :type="show1 ? 'text' : 'password'"
                label="Contraseña"
                hint="At least 8 characters"
                counter
                @click:append="show1 = !show1"
                filled
                dense
                clearable
                single-line
              ></v-text-field>
            </v-form>
          </v-card-text>
            
          <v-card-actions class="mx-3">
            <v-btn  color="red" block  dark @click="validate" class="elevation-5">Iniciar Sesión</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>

<script>
import {mapActions , mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  var md5     = require('md5')

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins: [ validarErrores ],

    data(){
      return{

        // Alertas
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },

        respuestaAlerta:false,
        loader: true,
        cargar: false,

        password: '',
        email:'',

        show1: false,
        error: '',


        valid: true,
        rules: {
          required: value => !!value || 'Requerido.',
          min: v => (v && v.length <= 10) || 'Minimo 8 caracteres'
        },

        NombreAsig: '',
        Nomuser: '',
      }
    },

    created(){
      if( this.getdatosUsuario ){
      console.log( this.getdatosUsuario ) 
        this.$router.push({ name: 'home' }) 
      }
    },


    methods:{
      ...mapActions('login',['GetInfoUser']),

      validate () {
        this.$refs.form.validate()
        if(this.$refs.form.validate() == true){
          this.ingresar()
        }
      },

      ingresar (){
        this.cargar = true

        var usuario = { "email" : this.email, "password": md5(this.password)}
        // Traemos la información del usuario
        this.GetInfoUser(usuario).then(response => {
          if( !response ){
            this.validarErrorDirecto('No cuentas con acceso al sistema')
          }else{
            this.$router.push({ name: 'home' })  
          }
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },
    },

    computed:{
      ...mapGetters('login',['getdatosUsuario'])
    }
  };


</script>

<style scoped>
</style>





  